document.addEventListener('DOMContentLoaded', function () {
  var cards = document.querySelectorAll('.card');
  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry, i) {
        if (entry.isIntersecting) {
          setTimeout(function () {
            entry.target.classList.add('in-view');
          }, i * 60);
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    cards.forEach(function (c) { observer.observe(c); });
  } else {
    cards.forEach(function (c) { c.classList.add('in-view'); });
  }

  var toggle = document.querySelector('.nav-toggle');
  var links = document.querySelector('nav .links');
  if (toggle && links) {
    toggle.addEventListener('click', function () {
      links.classList.toggle('mobile-open');
    });
  }

  var genderButtons = document.querySelectorAll('[data-gender-btn]');
  genderButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var gender = btn.getAttribute('data-gender-btn');
      document.body.classList.toggle('show-women', gender === 'women');
      genderButtons.forEach(function (b) { b.classList.remove('active'); });
      document.querySelectorAll('[data-gender-btn="' + gender + '"]').forEach(function (b) {
        b.classList.add('active');
      });
    });
  });

  /* PREDICTIVE SEARCH */
  var searchForms = document.querySelectorAll('[data-predictive-search]');
  searchForms.forEach(function (form) {
    var input = form.querySelector('[data-search-input]');
    var results = form.querySelector('[data-search-results]');
    var debounceTimer;

    function closeResults() {
      results.hidden = true;
      results.innerHTML = '';
    }

    function renderResults(data, query) {
      var products = (data.resources && data.resources.results && data.resources.results.products) || [];
      results.innerHTML = '';

      if (products.length === 0) {
        var empty = document.createElement('div');
        empty.className = 'search-empty';
        empty.textContent = 'No matches for "' + query + '"';
        results.appendChild(empty);
      } else {
        products.forEach(function (product) {
          var a = document.createElement('a');
          a.className = 'search-result-item';
          a.href = product.url;

          var img = document.createElement('img');
          img.src = product.featured_image ? (product.featured_image.url || product.image) : (product.image || '');
          img.alt = product.title;
          img.loading = 'lazy';
          if (!img.src) { img.style.display = 'none'; }
          a.appendChild(img);

          var info = document.createElement('div');
          info.className = 'sr-info';
          var title = document.createElement('span');
          title.className = 'sr-title';
          title.textContent = product.title;
          var price = document.createElement('span');
          price.className = 'sr-price';
          price.textContent = product.price || '';
          info.appendChild(title);
          info.appendChild(price);
          a.appendChild(info);

          results.appendChild(a);
        });
      }

      var viewAll = document.createElement('a');
      viewAll.className = 'search-view-all';
      viewAll.href = '/search?q=' + encodeURIComponent(query);
      viewAll.textContent = 'View All Results';
      results.appendChild(viewAll);

      results.hidden = false;
    }

    input.addEventListener('input', function () {
      var query = input.value.trim();
      clearTimeout(debounceTimer);

      if (query.length < 2) {
        closeResults();
        return;
      }

      debounceTimer = setTimeout(function () {
        var loading = document.createElement('div');
        loading.className = 'search-loading';
        loading.textContent = 'Searching...';
        results.innerHTML = '';
        results.appendChild(loading);
        results.hidden = false;

        fetch('/search/suggest.json?q=' + encodeURIComponent(query) +
          '&resources[type]=product&resources[limit]=6&resources[options][fields]=title,product_type,variants.title,tag')
          .then(function (res) { return res.json(); })
          .then(function (data) { renderResults(data, query); })
          .catch(function () { closeResults(); });
      }, 250);
    });

    document.addEventListener('click', function (e) {
      if (!form.contains(e.target)) { closeResults(); }
    });

    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { closeResults(); }
    });
  });

  /* SIGNUP POPUP */
  var popupOverlay = document.getElementById('SignupPopupOverlay');
  if (popupOverlay) {
    var dismissed = localStorage.getItem('hollowOakPopupDismissed');
    if (!dismissed) {
      var delay = parseInt(popupOverlay.getAttribute('data-popup-delay'), 10) || 2;
      setTimeout(function () {
        popupOverlay.hidden = false;
      }, delay * 1000);
    }
    var closeBtn = document.getElementById('SignupPopupClose');
    function dismissPopup() {
      popupOverlay.hidden = true;
      localStorage.setItem('hollowOakPopupDismissed', '1');
    }
    if (closeBtn) { closeBtn.addEventListener('click', dismissPopup); }
    popupOverlay.addEventListener('click', function (e) {
      if (e.target === popupOverlay) { dismissPopup(); }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !popupOverlay.hidden) { dismissPopup(); }
    });
  }

  /* PRODUCT CARD HOVER IMAGE CAROUSEL */
  document.querySelectorAll('.card').forEach(function (card) {
    var swatch = card.querySelector('.swatch');
    if (!swatch) return;
    var imgs = swatch.querySelectorAll('img');
    if (imgs.length < 2) return;

    var current = 0;
    var nav = document.createElement('div');
    nav.className = 'card-img-nav';

    var prevHalf = document.createElement('div');
    prevHalf.className = 'card-img-nav-half';
    var nextHalf = document.createElement('div');
    nextHalf.className = 'card-img-nav-half';
    nav.appendChild(prevHalf);
    nav.appendChild(nextHalf);
    swatch.appendChild(nav);

    var dots = document.createElement('div');
    dots.className = 'card-img-dots';
    imgs.forEach(function (_, i) {
      var dot = document.createElement('span');
      dot.className = 'card-img-dot' + (i === 0 ? ' active' : '');
      dots.appendChild(dot);
    });
    swatch.appendChild(dots);

    function show(index) {
      current = (index + imgs.length) % imgs.length;
      imgs.forEach(function (img, i) {
        img.classList.toggle('card-img-active', i === current);
      });
      dots.querySelectorAll('.card-img-dot').forEach(function (dot, i) {
        dot.classList.toggle('active', i === current);
      });
    }

    imgs[0].classList.add('card-img-active');

    prevHalf.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      show(current - 1);
    });
    nextHalf.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      show(current + 1);
    });
  });
});
